module.exports = __webpack_public_path__ + "img/ics_f_save.eafcbd50.svg";